export default "__VITE_ASSET__CGQqV2JF__"